export const posts_per_request = 9;

export const API = 'https://ping-proxies-dev.onrender.com/api';
export const MAIN_URL = 'https://ping-proxies-dev.onrender.com';

export const headers = {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer 33b8d8df6ab2086838375562802c2fa798cb1660e8cef26c6198480c08e6da519295e289de2a8946a6ecf0e330fe92eb4d5acef18ca98dcebd0d8f3e99dfb1126cd6c74d0d46cbd61b1fef08c0de1831bb4d44e4bd16bf2b53ed1f40a28c2e9b0191131abc9c62b72391425a1bc98d588db9334d9ebe3b2b07e4eb250f84cbc5'
};
